// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import { Box, Grid, Typography } from "@mui/material";
import MemberItem from "../components/MemberItem";
import { useEffect, useState } from "react";
/*
import {
  commandoList,
  chargenList,
  activeMembersList,
  honorMembersList,
  reserveMembersList,
} from "../data/teamData";
 */

function convertString2JsDate(dateString) {
  let dateArray = dateString.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  return new Date(dateArray[3], dateArray[2] - 1, dateArray[1]);
}

function loadMembers(jsonPath, setMembers, setLoadingMembers) {
  fetch(jsonPath, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    cache: "no-cache",
  })
    .then(function (originalResponse) {
      return originalResponse.json();
    })
    .then(function (jsonResponse) {
      let jsonRespWithDate = jsonResponse.map((element) => {
        if ("birthDate" in element) {
          element.birthDate = convertString2JsDate(element.birthDate);
        }
        if ("entryDate" in element) {
          element.entryDate = convertString2JsDate(element.entryDate);
        }
        return element;
      });
      if (setMembers && typeof setMembers == "function") {
        setMembers(jsonRespWithDate);
      }
      if (setLoadingMembers && typeof setLoadingMembers == "function") {
        setLoadingMembers(false);
      }
    })
    .catch((err) => console.log(err));
}

function Team() {
  const [commandoMembers, setCommandoMembers] = useState([]);
  const [chargeMembers, setChargeMembers] = useState([]);
  const [activeMembers, setActiveMembers] = useState([]);
  const [reserveMembers, setReserveMembers] = useState([]);
  const [honorMembers, setHonorMembers] = useState([]);
  const [loadingCommandoMembers, setLoadingCommandoMembers] = useState(true);
  const [loadingChargeMembers, setLoadingChargeMembers] = useState(true);
  const [loadingActiveMembers, setLoadingActiveMembers] = useState(true);
  const [loadingReserveMembers, setLoadingReserveMembers] = useState(true);
  const [loadingHonorMembers, setLoadingHonorMembers] = useState(true);

  useEffect(() => {
    loadMembers(
      process.env.PUBLIC_URL + "/data/membersCommando.json",
      setCommandoMembers,
      setLoadingCommandoMembers
    );
    loadMembers(
      process.env.PUBLIC_URL + "/data/membersChargen.json",
      setChargeMembers,
      setLoadingChargeMembers
    );
    loadMembers(
      process.env.PUBLIC_URL + "/data/membersActive.json",
      setActiveMembers,
      setLoadingActiveMembers
    );
    loadMembers(
      process.env.PUBLIC_URL + "/data/membersReserve.json",
      setReserveMembers,
      setLoadingReserveMembers
    );
    loadMembers(
      process.env.PUBLIC_URL + "/data/membersHonor.json",
      setHonorMembers,
      setLoadingHonorMembers
    );
  }, []);

  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        [theme.breakpoints.down("sm")]: {
          marginTop: 7,
        },
        [theme.breakpoints.up("sm")]: {
          marginTop: 20,
        },
      })}
      direction="column">
      {/* Gruppenfoto mit und ohne unterstützende Ehrenmitglieder */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ textAlign: "center" }}>
          Die Mannschaft
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}>
        <Box
          component="img"
          src={
            process.env.PUBLIC_URL + "/images/team/20230528_gruppenfoto_2.jpg"
          }
          alt="Gruppenfoto mit den Ehrenmitgliedern"
          sx={{ maxWidth: "100%" }}
        />
      </Grid>
      {/* Kommando */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ marginTop: 3, textAlign: "center" }}>
          Das Kommando
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}>
        <Box
          component="img"
          src={process.env.PUBLIC_URL + "/images/team/20230528_kommando.jpg"}
          alt="aktuelles Kommando"
          sx={{ maxWidth: "100%" }}
        />
      </Grid>
      {loadingCommandoMembers === false && (
        <Grid
          container
          item
          spacing={2}
          alignItems="stretch">
          {commandoMembers.map((member) => {
            return (
              <MemberItem
                key={member.id}
                memberData={member}
              />
            );
          })}
        </Grid>
      )}
      {/* Sachbearbeiter */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ marginTop: 3, textAlign: "center" }}>
          Die Sachbearbeiter
        </Typography>
      </Grid>
      {loadingChargeMembers === false && (
        <Grid
          container
          item
          spacing={2}
          alignItems="stretch">
          {chargeMembers.map((member) => {
            return (
              <MemberItem
                key={member.id}
                memberData={member}
              />
            );
          })}
        </Grid>
      )}
      {/* Aktive Mitglieder */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ marginTop: 3, textAlign: "center" }}>
          Weitere aktive Mitglieder
        </Typography>
      </Grid>
      {loadingActiveMembers === false && (
        <Grid
          container
          item
          spacing={2}
          alignItems="stretch">
          {activeMembers
            .sort(function (a, b) {
              let aname = a.lastname.toLowerCase() + a.firstname.toLowerCase();
              let bname = b.lastname.toLowerCase() + b.firstname.toLowerCase();

              if (aname < bname) {
                return -1;
              }
              if (aname > bname) {
                return 1;
              }
              return 0;
            })
            .map((member) => {
              return (
                <MemberItem
                  key={member.id}
                  memberData={member}
                />
              );
            })}
        </Grid>
      )}
      {/* Reserve Mitglieder */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ marginTop: 3, textAlign: "center" }}>
          Reserve Mitglieder
        </Typography>
      </Grid>
      {loadingReserveMembers === false && (
        <Grid
          container
          item
          spacing={2}
          alignItems="stretch">
          {reserveMembers
            .sort(function (a, b) {
              let aname = a.lastname.toLowerCase() + a.firstname.toLowerCase();
              let bname = b.lastname.toLowerCase() + b.firstname.toLowerCase();

              if (aname < bname) {
                return -1;
              }
              if (aname > bname) {
                return 1;
              }
              return 0;
            })
            .map((member) => {
              return (
                <MemberItem
                  key={member.id}
                  memberData={member}
                />
              );
            })}
        </Grid>
      )}
      {/* Ehrenmitglieder */}
      <Grid item>
        <Typography
          variant="h5"
          sx={{ marginTop: 3, textAlign: "center" }}>
          Ehrenmitglieder
        </Typography>
      </Grid>
      {loadingHonorMembers === false && (
        <Grid
          container
          item
          spacing={2}
          alignItems="stretch">
          {honorMembers
            .sort(function (a, b) {
              let aname = a.lastname.toLowerCase() + a.firstname.toLowerCase();
              let bname = b.lastname.toLowerCase() + b.firstname.toLowerCase();

              if (aname < bname) {
                return -1;
              }
              if (aname > bname) {
                return 1;
              }
              return 0;
            })
            .map((member) => {
              return (
                <MemberItem
                  key={member.id}
                  memberData={member}
                />
              );
            })}
        </Grid>
      )}
    </Grid>
  );
}

export default Team;
